// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContextMenu.css */

#context-menu {
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 5px 0;
  list-style: none;
  z-index: 1000;
}

#context-menu li {
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
}

#context-menu li:hover {
  background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/ContextMenu.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ContextMenu.css */\n\n#context-menu {\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  padding: 5px 0;\n  list-style: none;\n  z-index: 1000;\n}\n\n#context-menu li {\n  padding: 8px 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n#context-menu li:hover {\n  background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
